import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  TextField,
  Button,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Grid,
  Box,
  useMediaQuery,
  useTheme,
  Typography,
  Divider,
  Card,
  CardContent,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import {
  QuotationCreate,
  QuotationUpdate,
} from "../../../Services/Services";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CircularProgress } from "@mui/material";

export default function FreightEntryForm() {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const quoteData = location.state?.data ?? null;

  const getSelectedDivision = () => {
    try {
      const stored = localStorage.getItem("selectedDivision");
      return stored ? JSON.parse(stored) : null;
    } catch (e) {
      console.error("Failed to parse selectedDivision:", e);
      return null;
    }
  };

  const storedDivision = getSelectedDivision();

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    ref_no: "",
    date: "",
    to_name: "",
    to_company: "",
    to_address: "",
    contact_no: "",
    email: "",
    subject: "Quotation for Supply of Boiler Header Bend as per your inquiry.",
    body: "We are pleased to submit our quotation for the supply of Boiler Pressure Parts as per your inquiry.",
    gst_percent: "",
    validity: "",
    pf: "",
    transport_insurance: "",
    delivery: "",
    warranty: "",
    inspection_required: false,
    total_amount: 0,
    created_by: localStorage.getItem("user_id"),
    division: storedDivision?.division_id || "",
    payment_terms: [
      { payment: "30 % interest-free advance along with the order. " },
      { payment: "30 % against drawing approval & Inspection of Raw material at our workshop. " },
      { payment: "40% Balance against receipt of Performa invoice Before Material Dispatch." },
    ],
    scope_of_work: [
      { scope_of_work: "Manufacturing shall be taken up after receipt of advance payment, approved drawing. " },
      { scope_of_work: "Manufacturing will be done by using seamless steel tubes." },
      { scope_of_work: "Manufactured items will be duly Tested as per IBR 1950 & painted with two coats of red oxide paint." },
      { scope_of_work: "Material Test certificate shall be provided as per IBR Form III-B shall be provided." },
    ],
    exclusions: [
      { exclusions: "Modification is required in the existing system if any." },
      { exclusions: "Header and associated items, insulation/cladding, etc." },
      { exclusions: "All types of Taxes & Duties, levies by Govt. and local bodies, etc." },
      { exclusions: "Dismantling, Unloading, Erection &commissioning." },
    ],
    terms_and_conditions: [
      {
        key: "Price",
        value: "Our rates are valid for full quantity",
        is_default: true,
      },
      { key: "GST", value: "@ 18%  ", is_default: true },
      { key: "Validity", value: "10 Days", is_default: true },
      { key: "P & F", value: "EXCLUSIVE", is_default: true },
      {
        key: "Transportation and Insurance",
        value: "To Be arranged by Purchaser",
        is_default: true,
      },
      {
        key: "Delivery",
        value:
          "14 - 16 Weeks Delivery period shall be reckoned from the date of advance payment / approved drawing / IBR approval, whichever is later.",
        is_default: true,
      },
      {
        key: "Warranty for workmanship",
        value:
          "18 months /12 months - from date of dispatch/usage However, an Inspection from your end at our Works before dispatch is required",
        is_default: true,
      },
    ],
    items: [
      {
        description: "",
        unit: "",
        quantity: 0,
        rate: 0,
        amount: 0,
      },
    ],
  });
  const [errors, setErrors] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (!quoteData) return;

    setIsEditMode(true);
    const normalizedItems =
      Array.isArray(quoteData.items_list) && quoteData.items_list.length > 0
        ? quoteData.items_list.map((item) => ({
          unit: item.unit || item.uom || "",
          description: item.description ?? "",
          quantity: parseFloat(item.quantity) || 0,
          rate: parseFloat(item.rate) || 0,
          amount: parseFloat(item.amount) || 0,
        }))
        : [];

    const updatedData = {
      id: quoteData.quotation_id,
      ref_no: quoteData.ref_no,
      date: quoteData.date ? quoteData.date : "",
      to_name: quoteData.to_name || "",
      to_company: quoteData.to_company || "",
      to_address: quoteData.to_address || "",
      contact_no: quoteData.contact_no || "",
      email: quoteData.email || "",
      subject: quoteData.subject || "",
      body: quoteData.body || "",
      gst_percent: quoteData.gst_percent || "",
      validity: quoteData.validity || "",
      pf: quoteData.pf || "",
      transport_insurance: quoteData.transport_insurance || "",
      delivery: quoteData.delivery || "",
      warranty: quoteData.warranty || "",
      inspection_required: quoteData.inspection_required || false,
      total_amount: quoteData.total_amount || 0,
      payment_terms: quoteData.payment_terms || [],
      scope_of_work: quoteData.scope_of_work || [],
      exclusions: quoteData.exclusions || [],
      terms_and_conditions: quoteData.terms_and_conditions || [],
      division: storedDivision?.division_id || "",
      items:
        normalizedItems.length > 0
          ? normalizedItems
          : [
            {
              description: "",
              quantity: 0,
              rate: 0,
              amount: 0,
              unit: "",
            },
          ],
    };

    setFormData(updatedData);
  }, [quoteData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let error = "";
    let updatedValue = value;

    if (name === "contact_no") {
      updatedValue = value.replace(/\D/g, "");
      if (updatedValue.length > 10) {
        updatedValue = updatedValue.slice(0, 10);
      }
      if (updatedValue.length !== 10) {
        error = "Must be exactly 10 digits";
      } else {
        error = "";
      }
    }

    if (name === "email") {
      updatedValue = updatedValue.trim();
      if (updatedValue && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(updatedValue)) {
        error = "Invalid email format";
      } else {
        error = "";
      }
    }

    setFormData((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const handleQuotationSubmit = async (e) => {
    e.preventDefault();

    const userId = localStorage.getItem("user_id");
    if (!userId) {
      alert("User not logged in. Please login again.");
      return;
    }

    setLoading(true);
    try {
      const cleanedItems = formData.items.map((item) => ({
        ...item,
        unit: item.unit || item.uom,
      }));

      const payload = {
        ...formData,
        created_by: formData.created_by || userId,
        items: cleanedItems,
      };

      if (isEditMode) {
        await QuotationUpdate(payload.id, payload);
        toast.success("Quotation updated successfully!", {
          onClose: () => navigate("/dashboard/quotation"),
          autoClose: 2000,
        });
      } else {
        await QuotationCreate(payload);
        toast.success("Quotation created successfully!", {
          onClose: () => navigate("/dashboard/quotation"),
          autoClose: 2000,
        });
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong!", { autoClose: 3000 });
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteWithConfirmation = (sectionKey, idx) => {
    const updated = [...formData[sectionKey]];
    updated.splice(idx, 1);
    setFormData({ ...formData, [sectionKey]: updated });
  };

  const handleItemChange = (e, index) => {
    const { name, value } = e.target;
    const updatedItems = [...formData.items];

    // Text fields के लिए string, numeric fields के लिए number
    const updatedValue = name === "description" || name === "unit"
      ? value
      : Number(value) || 0;

    updatedItems[index][name] = updatedValue;

    // यदि quantity या rate बदला है, तो amount recalculate करें
    if (name === "quantity" || name === "rate") {
      const qty = Number(updatedItems[index].quantity) || 0;
      const rate = Number(updatedItems[index].rate) || 0;
      updatedItems[index].amount = qty * rate;
    }
    // यदि amount सीधे edit किया है, तो बस amount update करें
    // rate को untouched रहने दें
    // else if (name === "amount") कोई rate calculation नहीं

    const totalAmount = updatedItems.reduce(
      (sum, item) => sum + (Number(item.amount) || 0),
      0
    );

    setFormData((prev) => ({
      ...prev,
      items: updatedItems,
      total_amount: totalAmount,
    }));
  };

  const addItem = () => {
    setFormData((prev) => ({
      ...prev,
      items: [
        ...prev.items,
        {
          description: "",
          unit: "",
          quantity: 0,
          rate: 0,
          amount: 0,
        },
      ],
    }));
  };

  const deleteItem = (indexToDelete) => {
    const updatedItems = formData.items.filter((_, i) => i !== indexToDelete);
    const totalAmount = updatedItems.reduce(
      (sum, item) => sum + (Number(item.amount) || 0),
      0
    );
    setFormData((prev) => ({
      ...prev,
      items: updatedItems,
      total_amount: totalAmount,
    }));
  };

  const handleTermChange = (index, field, value) => {
    setFormData((prev) => {
      const updatedTerms = [...prev.terms_and_conditions];
      updatedTerms[index][field] = value;
      return {
        ...prev,
        terms_and_conditions: updatedTerms,
      };
    });
  };

  const addTerm = () => {
    setFormData((prev) => ({
      ...prev,
      terms_and_conditions: [
        ...prev.terms_and_conditions,
        { key: "", value: "", is_default: false },
      ],
    }));
  };

  const removeTerm = (index) => {
    setFormData((prev) => ({
      ...prev,
      terms_and_conditions: prev.terms_and_conditions.filter((_, i) => i !== index),
    }));
  };

  const keyLabelMap = {
    payment_terms: { fieldKey: "payment", label: "Payment" },
    scope_of_work: { fieldKey: "scope_of_work", label: "Scope of Work" },
    exclusions: { fieldKey: "exclusions", label: "Exclusions" },
  };

  return (
    <Container maxWidth="xl" sx={{ px: { xs: 1, sm: 2 }, py: 2 }}>
      <form onSubmit={handleQuotationSubmit} autoComplete="off">
        {/* 🔘 SUBMIT BUTTON */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 2,
            mb: 2,
            mt: { xs: 0, md: -3 },
          }}
        >
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={loading}
            fullWidth={isMobile}
            sx={{ height: { xs: 40, md: 36 } }}
          >
            {loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : isEditMode ? (
              "Update"
            ) : (
              "Submit"
            )}
          </Button>
        </Box>

        {/* 📋 HEADER INFO */}
        <Box border="1px solid #ccc" borderRadius="8px" mb={2} p={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                size={isMobile ? "small" : "medium"}
                label="Quotation Ref No"
                name="ref_no"
                value={formData.ref_no}
                onChange={handleChange}
                required
                disabled={isEditMode}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                size={isMobile ? "small" : "medium"}
                label="Date"
                name="date"
                type="date"
                value={formData.date}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                size={isMobile ? "small" : "medium"}
                label="To Name"
                name="to_name"
                value={formData.to_name}
                onChange={handleChange}
                required
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                size={isMobile ? "small" : "medium"}
                label="To Company"
                name="to_company"
                value={formData.to_company}
                onChange={handleChange}
                required
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                size={isMobile ? "small" : "medium"}
                label="Contact No."
                name="contact_no"
                value={formData.contact_no}
                onChange={handleChange}
                error={Boolean(errors.contact_no)}
                helperText={errors.contact_no}
                required
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                size={isMobile ? "small" : "medium"}
                label="Email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                error={Boolean(errors.email)}
                helperText={errors.email}
                required
              />
            </Grid>

            <Grid item xs={12} sm={6} md={12}>
              <TextField
                fullWidth
                size={isMobile ? "small" : "medium"}
                label="To Address"
                name="to_address"
                value={formData.to_address}
                onChange={handleChange}
                required
              />
            </Grid>

            <Grid item xs={12} sm={6} md={12}>
              <TextField
                defaultValue={" OFFER FOR SUPPLY OF SUPRE HEATER SPARES- BENDS SET"}
                fullWidth
                size={isMobile ? "small" : "medium"}
                label="Subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                size={isMobile ? "small" : "medium"}
                label="Body"
                name="body"
                value={formData.body}
                onChange={handleChange}
                multiline
                rows={isMobile ? 1 : 0}
              />
            </Grid>
          </Grid>
        </Box>

        {/* 📦 ITEMS TABLE (DESKTOP) / CARDS (MOBILE) */}
        {isMobile ? (
          /* 📱 MOBILE VIEW - CARDS */
          <Box sx={{ mb: 2 }}>
            {formData.items.map((item, index) => (
              <Card key={index} sx={{ mb: 2, boxShadow: 2 }}>
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 1,
                    }}
                  >
                    <Typography variant="subtitle2" fontWeight="bold">
                      Item #{index + 1}
                    </Typography>
                    <IconButton
                      color="error"
                      size="small"
                      onClick={() => deleteItem(index)}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Box>

                  <Divider sx={{ mb: 2 }} />

                  <Grid container spacing={1.5}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Description"
                        name="description"
                        value={item.description}
                        onChange={(e) => handleItemChange(e, index)}
                        multiline
                        maxRows={3}
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Quantity"
                        name="quantity"
                        type="number"
                        value={item.quantity}
                        onChange={(e) => handleItemChange(e, index)}
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Unit"
                        name="unit"
                        value={item.unit}
                        onChange={(e) => handleItemChange(e, index)}
                        required
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Rate"
                        name="rate"
                        type="number"
                        value={item.rate}
                        onChange={(e) => handleItemChange(e, index)}
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Amount"
                        name="amount"
                        type="number"
                        value={item.amount}
                        onChange={(e) => handleItemChange(e, index)}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            ))}

            <Button
              onClick={addItem}
              variant="outlined"
              fullWidth
              startIcon={<AddIcon />}
              sx={{ mb: 2 }}
            >
              Add Item
            </Button>

            {/* GRAND TOTAL */}
            <Box
              sx={{
                bgcolor: "#f5f5f5",
                p: 2,
                borderRadius: 1,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography variant="subtitle1" fontWeight="bold">
                Grand Total
              </Typography>
              <Typography variant="h6" color="primary" fontWeight="bold">
                ₹ {formData.total_amount.toFixed(2)}
              </Typography>
            </Box>
          </Box>
        ) : (
          /* 💻 DESKTOP VIEW - TABLE */
          <>
            <TableContainer
              component={Paper}
              sx={{
                position: "relative",
                mb: 2,
                overflowX: "auto",
              }}
            >
              <Table size="small" sx={{ tableLayout: "fixed", width: "100%" }}>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: "40%" }}>Description</TableCell>
                    <TableCell sx={{ width: "10%" }}>Qty</TableCell>
                    <TableCell sx={{ width: "15%" }}>Unit</TableCell>
                    <TableCell sx={{ width: "12%" }}>Rate</TableCell>
                    <TableCell sx={{ width: "15%" }}>Total</TableCell>
                    <TableCell sx={{ width: "8%" }}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {formData.items.map((item, index) => (
                    <TableRow key={index}>
                      {/* Description */}
                      <TableCell>
                        <TextField
                          fullWidth
                          size="small"
                          name="description"
                          value={item.description || ""}
                          onChange={(e) => handleItemChange(e, index)}
                          multiline
                          maxRows={3}
                        />
                      </TableCell>

                      {/* Quantity */}
                      <TableCell>
                        <TextField
                          fullWidth
                          size="small"
                          name="quantity"
                          type="number"
                          value={item.quantity || ""}
                          onChange={(e) => handleItemChange(e, index)}
                        />
                      </TableCell>

                      {/* Unit */}
                      <TableCell>
                        <TextField
                          fullWidth
                          size="small"
                          name="unit"
                          value={item.unit || ""}
                          onChange={(e) => handleItemChange(e, index)}
                        />
                      </TableCell>

                      {/* Rate */}
                      <TableCell>
                        <TextField
                          fullWidth
                          size="small"
                          name="rate"
                          type="number"
                          value={item.rate || ""}
                          onChange={(e) => handleItemChange(e, index)}
                        />
                      </TableCell>

                      {/* Amount/Total - EDITABLE */}
                      <TableCell>
                        <TextField
                          fullWidth
                          size="small"
                          name="amount"
                          type="number"
                          value={item.amount || ""}
                          onChange={(e) => handleItemChange(e, index)}
                        />
                      </TableCell>

                      {/* Delete Button */}
                      <TableCell align="center">
                        <IconButton
                          color="error"
                          onClick={() => deleteItem(index)}
                          size="small"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}

                  {/* Grand Total Row - Sticky */}
                  <TableRow
                    sx={{
                      position: "sticky",
                      bottom: 0,
                      backgroundColor: "#fff",
                      zIndex: 3,
                    }}
                  >
                    <TableCell
                      colSpan={4}
                      align="right"
                      sx={{ backgroundColor: "#fff" }}
                    >
                      <strong>Grand Total</strong>
                    </TableCell>
                    <TableCell sx={{ backgroundColor: "#fff" }}>
                      <TextField
                        fullWidth
                        size="small"
                        value={formData.total_amount || 0}
                        disabled
                      />
                    </TableCell>
                    <TableCell sx={{ backgroundColor: "#fff" }} />
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>

            <Button onClick={addItem} variant="outlined" sx={{ mb: 2 }}>
              + Add Item
            </Button>
          </>
        )}

        {/* ✅ TERMS AND CONDITIONS SECTION */}
        <Grid item xs={12}>
          <Box mt={3}>
            <Typography
              variant={isMobile ? "subtitle1" : "h6"}
              fontWeight="bold"
              mb={2}
              sx={{
                borderBottom: "2px solid #1976d2",
                paddingBottom: 1,
                display: "inline-block",
              }}
            >
              Terms & Conditions
            </Typography>

            <Paper
              elevation={0}
              sx={{
                p: 2,
                backgroundColor: "#f9f9f9",
                borderRadius: 2,
                border: "1px solid #e0e0e0",
              }}
            >
              {formData.terms_and_conditions.map((term, index) => (
                <Grid
                  container
                  spacing={isMobile ? 1 : 2}
                  key={index}
                  alignItems="center"
                  sx={{
                    mb: 1.5,
                    flexWrap: isMobile ? "wrap" : "nowrap",
                  }}
                >
                  {/* Term Key */}
                  <Grid item xs={12} sm={3} >
                    <TextField
                      fullWidth
                      size="small"
                      value={term.key}
                      onChange={(e) =>
                        handleTermChange(index, "key", e.target.value)
                      }
                      placeholder="Term Title"
                      label={isMobile ? "Term" : ""}
                      variant="outlined"
                      sx={{
                        backgroundColor: term.is_default ? "#f0f0f0" : "#fff",
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 1,
                        },
                      }}
                    />
                  </Grid>

                  {/* Term Value */}
                  <Grid item xs={10} sm={8}>
                    <TextField
                      fullWidth
                      size="small"
                      value={term.value}
                      onChange={(e) =>
                        handleTermChange(index, "value", e.target.value)
                      }
                      placeholder="Enter condition/value"
                      label={isMobile ? "Value" : ""}
                      variant="outlined"
                      multiline={isMobile}
                      maxRows={3}
                      sx={{
                        backgroundColor: "#fff",
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 1,
                        },
                      }}
                    />
                  </Grid>

                  {/* Delete Button */}
                  <Grid
                    item
                    xs={2}
                    sm={1}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <IconButton
                      onClick={() => removeTerm(index)}
                      color="error"
                      size="small"
                      sx={{
                        backgroundColor: term.is_default
                          ? "#e0e0e0"
                          : "#ffebee",
                        "&:hover": {
                          backgroundColor: term.is_default
                            ? "#e0e0e0"
                            : "#ffcdd2",
                        },
                      }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Grid>
                </Grid>
              ))}

              {/* Add Button */}
              <Box
                mt={2}
                display="flex"
                justifyContent={isMobile ? "center" : "flex-start"}
              >
                <Button
                  variant="outlined"
                  startIcon={<AddIcon />}
                  onClick={addTerm}
                  size={isMobile ? "small" : "medium"}
                  sx={{
                    borderRadius: 2,
                    textTransform: "none",
                    fontWeight: 500,
                  }}
                >
                  Add More Terms
                </Button>
              </Box>
            </Paper>

            {/* 📝 ADDITIONAL FIELDS */}
            <Box border="1px solid #ccc" borderRadius="8px" p={2} marginTop="5px">
              <Grid container spacing={2}>
                {/* Payment Terms, Scope of Work, Exclusions */}
                {Object.entries(keyLabelMap).map(
                  ([sectionKey, { fieldKey, label }]) => (
                    <Grid item xs={12} md={4} mt={2} key={sectionKey}>
                      {formData[sectionKey].map((item, idx) => (
                        <Box
                          key={idx}
                          sx={{ display: "flex", alignItems: "center", mb: 1 }}
                        >
                          <TextField
                            fullWidth
                            size={isMobile ? "small" : "medium"}
                            label={label}
                            value={item[fieldKey]}
                            error={!item[fieldKey].trim()}
                            helperText={
                              !item[fieldKey].trim()
                                ? `${label} cannot be empty`
                                : ""
                            }
                            onChange={(e) => {
                              const updated = [...formData[sectionKey]];
                              updated[idx][fieldKey] = e.target.value;
                              setFormData({ ...formData, [sectionKey]: updated });
                            }}
                          />

                          <Box
                            sx={{ display: "flex", flexDirection: "column", ml: 1 }}
                          >
                            <IconButton
                              size="small"
                              onClick={() =>
                                handleDeleteWithConfirmation(sectionKey, idx)
                              }
                              disabled={formData[sectionKey].length === 1}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                            {idx === formData[sectionKey].length - 1 && (
                              <IconButton
                                size="small"
                                onClick={() => {
                                  const updated = [...formData[sectionKey]];
                                  updated.push({ [fieldKey]: "" });
                                  setFormData({
                                    ...formData,
                                    [sectionKey]: updated,
                                  });
                                }}
                              >
                                <AddIcon fontSize="small" />
                              </IconButton>
                            )}
                          </Box>
                        </Box>
                      ))}
                    </Grid>
                  )
                )}
              </Grid>
              <ToastContainer position="top-right" autoClose={3000} />
            </Box>
          </Box>
        </Grid>
      </form>
    </Container>
  );
}